import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleProjectRemoval(
  state: State,
  project: Boundaries["removeProject"]["success"],
): State {
  return state.map((res) => ({
    ...res,
    projects: res.projects.filter(({ uuid }) => project.uuid !== uuid),
  }));
}

export { handleProjectRemoval };
